import ReactDOM from "react-dom";
import Amplify from "aws-amplify";

import { App } from "App";
import { SentryService, LogRocketService } from "shared/services";
import config from "config";

Amplify.configure(config.AWS);
SentryService.init();
LogRocketService.init();

ReactDOM.render(<App />, document.getElementById("root"));
